import { Link, useHistory } from 'react-router-dom';
import { IoPencil } from 'react-icons/io5';
import { useParams } from 'react-router';

export const MenuCategoryItems = ({ items }) => {
    const { location } = useHistory();
    const { slug } = useParams();
    const searchParams = new URLSearchParams(location.search);
    const statusParams = searchParams.get("status");
    const flatted =
        items?.flatMap((category) => {
            return [...category.dishes];
        }) || [];
    const filtered = statusParams === "archived"? flatted.filter(({archived_at}) => archived_at !== null): flatted.filter(({archived_at}) => archived_at === null);
    return (
        <div>
            {filtered.map(({ id, title, name, photo_thumb, photo }) => (
                <div key={id} className="bg-gray-100 flex items-center justify-between sm:rounded-lg my-1 mx-auto px-2 w-full h-16">
                    <div className="flex items-center p-2">
                        <Link to={`/chain/menu/${slug}/dishes/${id}/edit`} key={id} className="bg-gray-100 flex items-center justify-between sm:rounded-lg my-1 mx-auto px-2 w-full h-16">
                            <img className="rounded-l" width={45} height={45} src={photo_thumb ?? photo} alt="" />
                        </Link>
                        <span className="text-sm font-normal text-purple-500 px-11 whitespace-nowrap">
                            <Link to={`/chain/menu/${slug}/dishes/${id}/edit`}>{title || name || ""}</Link>
                        </span>
                    </div>

                    <div className="flex items-center pr-3.5">
                        <Link to={`/chain/menu/${slug}/dishes/${id}/edit`}>
                            <IoPencil className="text-indigo-600 cursor-pointer" />
                        </Link>
                    </div>
                </div>
            ))}
        </div>
    );
};
